import { FormControl } from "@angular/forms";
import { ReplaySubject, Subject, take, takeUntil } from "rxjs";
import { IdName } from "../dtos/IdName";

export type MultiType = IdName | string;
export class MultiSelectSearch<T extends MultiType> {

    public multiFilterCtrl: FormControl<string | null> = new FormControl<string>('');

    /** list of options filtered by search keyword */
    public filteredMulti: ReplaySubject<T[]> = new ReplaySubject<T[]>(1);

    /** local copy of filtered options to help set the toggle all checkbox state */
    protected filteredCache: T[] = [];

    private isStringArray: boolean = false

    /** flags to set the toggle all checkbox state */
    isIndeterminate = false;
    isChecked = false;
    public _onDestroy = new Subject<void>();

    constructor(private formControlName: FormControl, private options: T[], private selectionChangeCallback?: (value: number[]) => void) {
        this.filteredMulti.next(this.options.slice());

        // listen for search field value changes
        this.multiFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterOptions();
                this.setToggleAllCheckboxState();
            });

        // listen for multi select field value changes
        this.formControlName.valueChanges.pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.setToggleAllCheckboxState();
            })

    }

    setOptions(options: T[]): void {
        this.options = options;
        this.checkOptionType();
        this.filterOptions();
        this.setToggleAllCheckboxState();
    }

    private checkOptionType(): void {
        if (this.options && this.options.length > 0) {
            this.isStringArray = typeof this.options[0] === 'string';
        } else {
            this.isStringArray = false;
        }
    }

    // toggleSelectAll(selectAllValue: boolean) {
    //     this.filteredMulti.pipe(take(1), takeUntil(this._onDestroy))
    //         .subscribe(val => {
    //             if (selectAllValue) {
    //                 const valuesToPatch = this.isStringArray ? val : (val as IdName[]).map(option => option.id)
    //                 this.formControlName.patchValue(valuesToPatch);
    //             } else {
    //                 // this.StudyMultiCtrl.patchValue([]);
    //                 this.formControlName.patchValue([]);
    //             }
    //         });
    // }

    toggleSelectAll(selectAllValue: boolean) {
        const val = this.filteredCache;
        let valuesToPatch: any;
        if (selectAllValue) {
            valuesToPatch = this.isStringArray ? val : (val as IdName[]).map(option => option.id);
        } else {
            valuesToPatch = [];
        }
        this.formControlName.patchValue(valuesToPatch);

        if (this.selectionChangeCallback) {
            this.selectionChangeCallback(valuesToPatch);
        }
    }

    // protected filterOptions() {
    //     if (!this.options) {
    //         return;
    //     }
    //     // get the search keyword
    //     let search = this.multiFilterCtrl.value;
    //     if (!search) {
    //         this.filteredCache = this.options.slice();
    //         this.filteredMulti.next(this.filteredCache);
    //         return;
    //     } else {
    //         search = search.toLowerCase();
    //     }
    //     // filter the options
    //     this.filteredCache = this.options.filter(option => option.name && option.name.toLowerCase().indexOf(search) > -1);
    //     this.filteredMulti.next(this.filteredCache);
    // }

    protected filterOptions() {
        if (!this.options) {
            return;
        }
        // get the search keyword
        let search = this.multiFilterCtrl.value;
        if (!search) {
            this.filteredCache = this.options.slice();
            this.filteredMulti.next(this.filteredCache);
            return;
        } else {
            search = search.toLowerCase();
        }

        if (this.isStringArray) {
            this.filteredCache = this.options.filter(option => (option as string).toLocaleLowerCase().includes(search));
        } else {
            this.filteredCache = this.options.filter(option => (option as IdName).name.toLocaleLowerCase().includes(search));
        }

        this.filteredMulti.next(this.filteredCache);
        // filter the options
        // this.filteredCache = this.options.filter(option => option.name && option.name.toLowerCase().indexOf(search) > -1);
        // this.filteredMulti.next(this.filteredCache);
    }

    // protected setToggleAllCheckboxState() {
    //     let filteredLength = 0;
    //     if (this.formControlName && this.formControlName.value) {
    //         this.filteredCache.forEach(el => {
    //             if (this.formControlName.value && this.formControlName.value.indexOf(el) > -1) {
    //                 filteredLength++;
    //             }
    //         });
    //         this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredCache.length;
    //         this.isChecked = filteredLength > 0 && filteredLength === this.filteredCache.length;
    //     }
    // }

    protected setToggleAllCheckboxState() {
        let filteredLength = 0;

        // Make sure all values exist before proceeding
        if (!this.formControlName || !this.formControlName.value || !this.filteredCache || this.filteredCache.length === 0) {
            this.isIndeterminate = false;
            this.isChecked = false;
            return;
        }

        const selectedValues: any[] = this.formControlName.value;

        this.filteredCache.forEach(el => {
            if (this.isStringArray) {
                // Case 1: Compare string to string
                if (selectedValues.indexOf(el as string) > -1) {
                    filteredLength++;
                }
            } else {
                // Case 2: Compare number (el.id) to number
                const optionId = (el as IdName).id;
                if (selectedValues.indexOf(optionId) > -1) {
                    filteredLength++;
                }
            }
        });

        this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredCache.length;
        this.isChecked = filteredLength > 0 && filteredLength === this.filteredCache.length;
    }
}